export const GoogleCalendarHowItWorks: React.FC = () => {
  return (
    <div>
      <p>
        Connect your Google Calendar to give Zocks access to your meeting schedule. Once connected, Zocks automatically syncs your upcoming meetings and can
        join them without manual invitation.
      </p>
      <p>
        Your meetings appear in Zocks' Upcoming Meetings list, giving you visibility into what's ahead. This enables you to prepare for meetings in advance by
        reviewing your Meeting Prep.
      </p>
      <p>
        When a meeting starts, Zocks joins automatically. No need to remember to invite your AI Assistant - it's already there, ready to analyze your
        conversation.
      </p>
    </div>
  )
}
